import { useEffect } from 'react';

import styles from './CompanyAccounts.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DragDropUpload from '../components/DragDropUpload/DragDropUpload';
import FileStatusSections from '../components/FileStatusSections/FileStatusSections';

const DOCUMENT_TYPE = 'business accounts';
const listOfInstructions = [
  <>
    Include the P&L page and latest balance sheet broken down by items.{' '}
    <a
      href="https://effective-accounting.co.uk/blog/what-is-included-in-my-company-accounts/"
      target="_blank"
      rel="noreferrer"
    >
      Learn more
    </a>
  </>,
  'Don’t supply draft versions',
  'PDF format only',
];
const CompanyAccounts = () => {
  const stateKey = useContextStateKey();

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  const { documents } = useGetDocuments(stateKey);

  useEffect(() => {
    if (documents) {
      const VATreturnsDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(VATreturnsDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <DragDropUpload
        documentType={DOCUMENT_TYPE}
        listOfInstructions={listOfInstructions}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
      />
      <FileStatusSections files={uploadedFiles} removeFile={removeFile} />
    </div>
  );
};

export default CompanyAccounts;
